import { render, staticRenderFns } from "./FinanceTrackerRecordsSummary.vue?vue&type=template&id=08a21689&"
import script from "./FinanceTrackerRecordsSummary.vue?vue&type=script&lang=js&"
export * from "./FinanceTrackerRecordsSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports